import { gql } from '@/__generated__';

export const GATE_MESSAGE_RECEIVED = gql(`#graphql
  subscription GateMessageReceived($gateId: ID) {
    gateMessageReceived(gateId: $gateId) {
      id
      movements {
        id
        operatingState
        lastPosition {
          value
          unit
          precision
          source
          timestamp
        }
        lastBattery {
          value
          unit
          precision
          source
          timestamp
        }
        lastConnection {
          connected
          source
          timestamp
        }
        unit
        precision
        activeMovement {
          ...GateMovementFragment
        }
        lastMovement {
          ...GateMovementFragment
        }
      }
      movement {
        ...GateMovementFragment
      }
      type
      payload
      timestamp
    }
  }
`);
